const $ = jQuery;

export default class Flyout {
    constructor() {
        this._initMobileMenu();
        this._initDesktopMenu();

        $(window).on('resize', () => {
            $('.menu__item').removeClass('menu__item--toggled');
        });
    }

    _initMobileMenu() {
        $('.menu__toggle, .menu__link-wrapper').on('click', (e) => {
            e.preventDefault();
            if (!$(e.currentTarget).parent('.menu__item').hasClass('menu__item--current')) {
                $(e.currentTarget).parent('.menu__item').toggleClass('menu__item--toggled');
            }
            $(e.currentTarget).parent('.menu__item').removeClass('menu__item--current');
            $(e.currentTarget).parent('.menu__item').removeClass('menu__item--ancestor');
        });
    }

    _initDesktopMenu() {
        $('.menu__item--0').on({
            'mouseenter touchstart': (e) => {
                if (this._isMobileView()) {
                    return;
                }
                if (!$(e.currentTarget).hasClass('menu__item--toggled') && $(e.currentTarget).find('.menu__list').length > 0) {
                    e.preventDefault();
                }
                $(e.currentTarget).addClass('menu__item--toggled');

            },
            mouseleave: (e) => {
                e.preventDefault();
                if (this._isMobileView()) {
                    return;
                }
                $(e.currentTarget).removeClass('menu__item--toggled');
            }
        });
    }

    _isMobileView() {
        return $('.page__header').find('.page__actions').is(':visible');
    }


}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/Flyouts.js